import type { mutate as mutateFn } from 'swr';

import { SWRConfig, useSWRConfig } from 'swr';

import crossFrameSwrCache from './utils/crossFrameSwrCache';

/**
 * SWR mutate function scoped to the SuperHub's custom SWR cache provider.
 * Useful for triggering revalidation of data from our zustand store functions.
 */
// eslint-disable-next-line import-x/no-mutable-exports
export let mutate: typeof mutateFn = (() => {
  // eslint-disable-next-line no-console
  console.error('SWR provider not initialized');
  return Promise.resolve();
}) as typeof mutateFn;

/**
 * Expose the scoped mutate function so it can be called outside of the
 * SWRConfig context's react tree.
 */
function ExposeSwrConfig() {
  const { mutate: scopedMutate } = useSWRConfig();
  mutate = scopedMutate;
  return null;
}

/**
 * Initializes a custom SWR cache provider for the SuperHub,
 * with a swr cache that can be shared with the Hub app
 * running in the iframe preview.
 */
export function InitializeSwr({ children, value }: Parameters<typeof SWRConfig>[0]) {
  return (
    <SWRConfig value={{ provider: crossFrameSwrCache, ...value }}>
      <ExposeSwrConfig />
      {children}
    </SWRConfig>
  );
}
